import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import Input from '../ui/Input';
import Button from '../ui/Button';
import RadioButtonContainer from '../ui/RadioButtonContainer';
import MobSelectButton from '../ui/MobSelectButton';
import AnimationForm from '../SelectForms/AnimationForm';
import textError from './textError'
import { checkNotEmptyValue, findValueInCatalog } from '../utils/utils'
import { calendarInc } from './statusForms/image';
import { idField, translateFields } from '../utils/localCatalog';
import { sendAnalyticsEventToNative } from '../utils/analytics';

const checkTypeDoc = value => {
  if(!value)
    return 'passport'
  return value === 1 ? 'passport' : 'idCard'
}
const formatData = data => (data && data.length) ? data.split('@')[0] : ''
const checkTypeDevice = () => {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    if(navigator.userAgent.indexOf('Android') !== -1)
      return 'android'
    else if(navigator.userAgent.indexOf('iPhone') !== -1)
      return 'iphone'
  }
  return ''
}
const checkFormatDate = () => checkTypeDevice() === 'iphone' ? 'YYYY-MM-DD' : 'DD.MM.YYYY'
class Documents extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      data: {
        typeDocument: checkTypeDoc(props.userData.typeDocument),
        numDoc:props.userData.numDoc || '',
        seria: props.userData.seria || '',
        count: props.userData.count || '',
        region: props.userData.region || 0,
        education: props.userData.education || 0,
        marital: props.userData.marital || 0,
        dateDoc: props.userData.dateDoc ?  moment(formatData(props.userData.dateDoc)).format(checkFormatDate()) : '',
        birthDay: moment(formatData(props.userData.birthDay)).format('YYYY-MM-DD')
      },
      errorValid: false,
      nextForm: false,
      typeDevice: checkTypeDevice()
    }
    this.ignoreValidation = !props.userData.typeDocument || props.userData.typeDocument === 1 ? [] : ['seria']
    this.textInputNumber = React.createRef()
    this.inputSerial = React.createRef()
    this.notSaveData = false
  }

  componentDidMount(){
    sendAnalyticsEventToNative('ecoCreditCardOrderStep2')
  }

  componentWillUnmount(){
    const {data, nextForm} = this.state
    if(!nextForm){
      const formData = {}
      formData.docTypeId = data.typeDocument === 'passport' ? 1 : 2
      formData.docSeries = data.typeDocument === 'passport' ? data.seria : ''
      formData.docNumber = data.numDoc
      formData.docIssueDate = moment(data.dateDoc.split('.').reverse().join('-')).format('YYYY-MM-DD@HH:mm:ss')
      formData.dependentsNumber = data.count
      formData.liveRegionId = data.region
      formData.educationId = data.education
      formData.maritalId = data.marital
      if(!this.notSaveData){
        this.props.onSubmitData(formData, true)
      }
    }
  }
  onCheckRadio = e => {
    const {id} = e.target
    if(id === 'passport'){
      this.ignoreValidation = this.ignoreValidation.filter(itemIgnore => itemIgnore !== 'seria')
    } else {
      this.ignoreValidation = [...this.ignoreValidation, 'seria']
    }
    this.setState({
      data: {
        ...this.state.data,
        typeDocument: id,
        numDoc: '',
        seria: ''
      }}, () => {
        if(id === 'passport')
          this.inputSerial.current.inputElement.focus()
        else
          this.textInputNumber.current.focus()
      })


      this.props.sendHistory({
        revType: this.props.userData.clickedDocType === undefined ? 1 : 2,
        fieldId: idField.typeDocument,
        oldValue:  this.props.userData.typeDocument === 'passport' ? 1 : 2,
        newValue: id === 'passport' ? 1 : 2
      })

      
      this.props.onSubmitData({
        [translateFields['typeDocument']]: id,
        clickedDocType: true
      }, true)
  }

  onChange = (e) => {
    const {name, value} = e.target
    const regNumberDoc = this.state.data.typeDocument === 'passport' ? /^[0-9]{0,6}$/ : /^[0-9]{0,9}$/
    const regCount = /^[0-9]{0,2}$/
    let newValue
    if(value === '')
      newValue = value
    else if(name === 'count' && regCount.test(value)){
      if(value === '' || (parseInt(value) >= 0 && parseInt(value) <= 99))
        newValue = value
    } else if(name === 'seria'){
      if(value.length === 2)
        this.textInputNumber.current.focus()
      newValue = value.toUpperCase() 
    } else if(name === 'numDoc' && regNumberDoc.test(value))
        newValue = value
      else if(name === 'dateDoc')
        newValue = value


    if(newValue || newValue === '') {
      this.setState({
        data: {
          ...this.state.data,
          [name]: newValue
        }
      })
    }
  }

  sendHistory = (e) => {
    const {userData } = this.props
    const name = e.target.name
    const oldValue = userData[name]
    
    let value = e.target.value
    
    if(name === 'dateDoc') {
      if(value !== '') {
        value = moment(value.split('.').reverse().join('-')).format('YYYY-MM-DD@HH:mm:ss')
      }
    } 

    if(name === 'seria'){
      value = value.toUpperCase()
    }
    
    const revType = oldValue === undefined ? 1 : 2

    if(oldValue !== value && (revType === 1 ? checkNotEmptyValue(value) : true)) {
  
      this.props.sendHistory({
        revType,
        fieldId: idField[name],
        oldValue,
        newValue: value
      })

      this.props.onSubmitData({
        [translateFields[name]]: value
      }, true)

    }
    
  }



  submit = e => {
    e.preventDefault()
    const checkSerialValidation = !this.ignoreValidation.some(itemIgnore => itemIgnore === 'seria')
    if(this.validation() &&
      (checkSerialValidation ? !this.checkValidData('seria') :  true) &&
      // eslint-disable-next-line max-len
      !this.checkValidData('numDoc') && !this.vDate().length && (this.state.typeDevice === 'iphone' ? true : this.validationDate())
    ){
      const {data} = this.state
      const formData = {}
      formData.docTypeId = data.typeDocument === 'passport' ? 1 : 2
      formData.docSeries = data.typeDocument === 'passport' ? data.seria : ''
      formData.docNumber = data.numDoc
      formData.docIssueDate = data.dateDoc.length
        ? moment(data.dateDoc.split('.').reverse().join('-')).format('YYYY-MM-DD@HH:mm:ss')
        : ''
      formData.dependentsNumber = data.count
      formData.liveRegionId = data.region
      formData.educationId = data.education
      formData.maritalId = data.marital

      if(!this.props.userData.clickedDocType){
        this.props.onSubmitData({
          clickedDocType: true
        }, true)
        this.props.sendHistory({
          revType: this.props.userData.clickedDocType === undefined ? 1 : 2,
          fieldId: idField.typeDocument,
          oldValue:  '',
          newValue: this.props.userData.typeDocument
        })
      }

      

      this.setState({nextForm: true}, () =>  this.props.onSubmitData(formData))
    } else
      this.setState({
        errorValid: true
      })
  }
  validation = () => (
    Object.keys(this.state.data)
    .filter(itemFilter => !this.ignoreValidation.some(itemIgnore => itemFilter === itemIgnore))
    .every(item => {
      if(typeof this.state.data[item] === 'number')
        return this.state.data[item] !== 0
      return this.state.data[item].length !== 0
    })
  )
  checkValidData = name => {
    const {data} = this.state
    if (name === 'seria'){
      if(data[name].length < 2)
        return textError.serialPassport
      return false
    } else if(name === 'numDoc'){
      if(data.typeDocument === 'passport' && data.numDoc.length < 6)
        return textError.numberPassport
      else if(data.typeDocument !== 'passport' && data.numDoc.length < 9)
        return textError.numberIdCard
      else if(parseInt(data.numDoc) === 0)
        return textError.incorrect
      return false
    }
  }
  onSelect = (name, value) => {
    this.setState({data: {...this.state.data, [name]: value}}) 

    this.sendHistory({
      target: {
        name,
        value
      }
    })
  }
  checkMinDate = () => {
    const {birthDay} = this.state.data
    // const b = birthDay.split('.').reverse().join('-')
    if(moment(birthDay).format('x') > moment('1991-01-01').format('x'))
      return moment(birthDay).format('x')
    return moment('1991-01-01').format('x')
  }
  validationDate = () => {
    var arrD = this.state.data.dateDoc.split(".");
    arrD[1] -= 1;
    var d = new Date(arrD[2], arrD[1], arrD[0]);
    if ((d.getFullYear() == arrD[2]) && (d.getMonth() == arrD[1]) && (d.getDate() == arrD[0])) {
        return true;
    } else {
      return false;
    }
  }
  vDate = () => {
    const {dateDoc} = this.state.data
    const maxDate = moment().format('x')
    const minDate = this.checkMinDate()
    const d = dateDoc.split('.').reverse().join('-')
    const currentDate = moment(d).format('x')
    if(parseInt(currentDate) < parseInt(minDate)){
      return `Дата не може бути меншою за ${moment(parseInt(minDate)).format('DD.MM.YYYY')}`
    } else if(parseInt(currentDate) > parseInt(maxDate))
      return `Дата не може бути більшою за ${moment(parseInt(maxDate)).format('DD.MM.YYYY')}`
    else if(dateDoc.length === 0)  
      return textError.dateDocument
    return ''
  }
  handleClickNotValidData = (e) => {
    e.preventDefault()
    this.notSaveData = true
    this.props.showNotValidForm()
  }

  render(){
    const {onShowForm, derictory, isClient, blockedFields} = this.props
    const {data, errorValid, typeDevice} = this.state
    const {typeDocument, numDoc, seria, count, region, education, marital, dateDoc} = data
    return(
      <form className="document-information" onSubmit={this.submit}>
        <AnimationForm onSelect={this.onSelect}/>
        <div className="scroll-container">
          <div className="document-info">
            <RadioButtonContainer
              title='Документ що засвідчує особу'
              name='typeDocument'
              data={[
                {id: 'passport', title: 'Паспорт громадянина України'},
                {id: 'idCard', title: 'Паспорт (id-картка)'}
              ]}
              onChange={this.onCheckRadio}
              checked={typeDocument}
              disabled={blockedFields.docTypeId}
            />
            <div className="form-input-container">
              {typeDocument === 'passport' && <Input
                name='seria'
                value={seria}
                onChange={this.onChange}
                onResetNumber={this.onResetNumber}
                mask={[/[а-яёї]/i,/[а-яёї]/i]}
                placeholder=''
                title='Серія'
                className='serial'
                textValid={errorValid && this.checkValidData('seria')}
                autoFocus={true}
                setRef={this.inputSerial}
                disabled={blockedFields.docNumber}
                onBlur={this.sendHistory}
              />}
              <Input
                name='numDoc'
                value={numDoc}
                onChange={this.onChange}
                onResetNumber={this.onResetNumber}   
                title='Номер документу'
                className='number-doc'
                textValid={errorValid && this.checkValidData('numDoc')}
                setRef={this.textInputNumber}
                type='tel'
                pattern='\d*'
                disabled={blockedFields.docNumber}
                onBlur={this.sendHistory}
              />
            </div>
            {typeDevice === 'iphone' ? (
              <div className="data-container">
                <div className="title-container">
                  {calendarInc}
                  <span className="title-text">Дата видачі</span>
                </div>
                <input
                  type='date'
                  name='dateDoc'
                  min={this.checkMinDate()}
                  max={moment().format('YYYY-MM-DD')}
                  value={dateDoc}
                  onChange={this.onChange}
                  disabled={blockedFields.docIssueDate}
                  onBlur={this.sendHistory}
                />
                {<span className='error-message'>{errorValid && dateDoc.length === 0 && textError.dateDocument}</span>}
              </div>
            ) : (
              <div className="data-container dateBirthday">
                <div className="title-container">
                  {calendarInc}
                  <span className="title-text">Дата видачі</span>
                </div>
                <Input
                  name='dateDoc'
                  value={dateDoc}
                  onChange={this.onChange}
                  // onResetNumber={this.onResetNumber}
                  className='calendar'
                  mask={[/\d/,/\d/, '.', /\d/, /\d/, '.',/\d/,/\d/, /\d/, /\d/]}
                  placeholder='dd.mm.yyyy'
                  // textValid={(errorStateCode || errorValid) && (this.innValidation('stateCode'))}
                  typeMask='tel'
                  pattern='^[.0-9]+$'
                  disabled={blockedFields.docIssueDate}
                  onBlur={this.sendHistory}
                />
                <span className='error-message'>
                  {errorValid && dateDoc.length !== 0 && !this.validationDate() && textError.errorFormatDate}
                  {errorValid && dateDoc.length === 0 && textError.dateDocument}
                  {errorValid && dateDoc.length !== 0 && this.validationDate() && this.vDate()}
                </span>
              </div>
            )}
              <Input
                name='count'
                value={count}
                onChange={this.onChange}
                onResetNumber={this.onResetNumber}
                title='Кількість утриманців'
                className='count'
                maxLength={2}
                type='tel'
                textValid={errorValid && (count.length !== 0 ? '' : textError.emptyCountUtr)}
                pattern='\d*'
                disabled={blockedFields.dependentsNumber}
                onBlur={this.sendHistory}
              />
            <div className="form-select-container">
              <MobSelectButton
                title='Регіон проживання'
                value={findValueInCatalog(derictory.region, region)}
                onClick={() => onShowForm('region', 'Регіон проживання', region)}
                textValid={errorValid && (region === 0)}
                disabled={blockedFields.liveRegionId}
              />
              <MobSelectButton
                title='Освіта'
                value={findValueInCatalog(derictory.education, education)}
                onClick={() => onShowForm('education', 'Освіта', education)}
                textValid={errorValid && (education === 0)}
                disabled={blockedFields.educationId}
              />
              <MobSelectButton
                title='Сімейний стан'
                value={findValueInCatalog(derictory.marital, marital)}
                onClick={() => onShowForm('marital', 'Сімейний стан', marital)}
                textValid={errorValid && (marital === 0)}
                disabled={blockedFields.maritalId}
              />
            </div>
          </div>
          <div className='button-container-footer'>
          <Button
              type='submit'
              title={isClient ? 'Підтвердити правильність даних та перейти далі' : 'Далі'}
              color={this.validation() ? 'success' : 'disable'}
            />
            {isClient && <Button
              type='button'
              title='Не підтверджую  правильність введених даних'
              color={'success'}
              onClick={this.handleClickNotValidData}
            />}
          </div>
        </div>
      </form>
    )
  }
}

Documents.propTypes = {
  onShowForm: PropTypes.func.isRequired,
  onSubmitData: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    typeDocument: PropTypes.number.isRequired,
    numDoc: PropTypes.string.isRequired,
    seria: PropTypes.string.isRequired,
    count: PropTypes.string.isRequired,
    region: PropTypes.string.isRequired,
    education: PropTypes.string.isRequired,
    marital: PropTypes.string.isRequired,
    dateDoc: PropTypes.string.isRequired,
    birthDay: PropTypes.string.isRequired,
    clickedDocType: PropTypes.bool.isRequired
  }),
  derictory: PropTypes.shape({
    region: PropTypes.array,
    education: PropTypes.array,
    marital: PropTypes.array,
  }).isRequired,
  blockedFields: PropTypes.object,
  showNotValidForm: PropTypes.func.isRequired,
  isClient: PropTypes.bool,
  sendHistory: PropTypes.func.isRequired
}

export default Documents